<sl-title title="Unit Setup"></sl-title>
<sl-form [form]="form" [fields]="formlyFields" [model]="model" [options]="formlyFormOptions">
	<sl-button-bar *ngIf="form?.dirty" (canceled)="cancelChanges()" (submitted)="saveChanges()"></sl-button-bar>
</sl-form>